<div class="homecomponent">
  <div class="text-heading-3 important-content">Important actions</div>
  <div>
    <ul class="nav nav-pills mb-3" id="homepills" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'alerts'" (click)="setActiveTab('alerts')" type="button" role="tab" aria-controls="pills-home" aria-selected="false">
          <div><img src="../../../assets/images/storelist/alerts.svg" alt="alerts"></div>
          <div class="headerName text-heading-6">Alerts & Notifications</div>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'stores'" (click)="setActiveTab('stores')" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
          <div><img src="../../../assets/images/storelist/stores.svg" alt="stores"></div>
          <div class="headerName text-heading-6">Stores</div>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'warehouse'" (click)="setActiveTab('warehouse')" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">
          <div><img src="../../../assets/images/storelist/warehouse.svg"></div>
          <div class="headerName text-heading-6">Warehouse</div>
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <app-alerts-notify *ngIf="activeTab === 'alerts'"></app-alerts-notify>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <app-stores-list *ngIf="activeTab === 'stores'"></app-stores-list>
      </div>
      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <app-stock-warehouse *ngIf="activeTab === 'warehouse'"></app-stock-warehouse>
      </div>
    </div>
  </div>
</div>
